"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _jquery = _interopRequireDefault(require("jquery"));
var _get = _interopRequireDefault(require("lodash/get"));
var _isNumber = _interopRequireDefault(require("lodash/isNumber"));
var _Player2 = _interopRequireDefault(require("../models/Player"));
var _mediaFormats = _interopRequireDefault(require("../constants/mediaFormats"));
var _htmlMediaEvents = _interopRequireDefault(require("../constants/htmlMediaEvents"));
var _timeToPercentage = _interopRequireDefault(require("../utils/timeToPercentage"));
var _playerName = _interopRequireDefault(require("../constants/playerName"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /* eslint-disable no-underscore-dangle */
var jPlayerFormatsMap = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _mediaFormats["default"].mp3, 'mp3'), _mediaFormats["default"].aac, 'm4a'), _mediaFormats["default"].ogg, 'oga'), _mediaFormats["default"].flash, 'rtmpa'), _mediaFormats["default"].hls, 'm3u8a');
var mediaErrorCodeMap = {
  1: 'MediaErrorAborted',
  2: 'MediaErrorNetwork',
  3: 'MediaErrorDecode',
  4: 'MediaErrorSourceNotSupported'
};
function onError(callback, mediaElement) {
  return function (event) {
    var type = event.type,
      data = event.data;
    var error = new Error("".concat(_playerName["default"].JPlayer, " error"));
    var mediaError = (0, _get["default"])(mediaElement, 'error') || {};
    error.errorData = {
      type: type,
      data: data,
      name: mediaErrorCodeMap[mediaError.code],
      message: mediaError.message,
      isMediaError: !!mediaError.code
    };
    return callback(error);
  };
}
var JPlayer = exports["default"] = /*#__PURE__*/function (_Player) {
  (0, _inherits2["default"])(JPlayer, _Player);
  function JPlayer(config) {
    var _this;
    (0, _classCallCheck2["default"])(this, JPlayer);
    _this = _callSuper(this, JPlayer, [_playerName["default"].JPlayer]);
    _this.jPlayerLibrary = config.jPlayerInstance;
    _this.playerEl = config.mediaElement;
    _this.volume = null;
    _this.jPlayerEventMap = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _htmlMediaEvents["default"].playing, _jquery["default"].jPlayer.event.playing), _htmlMediaEvents["default"].play, _jquery["default"].jPlayer.event.play), _htmlMediaEvents["default"].progress, _jquery["default"].jPlayer.event.progress), _htmlMediaEvents["default"].waiting, _jquery["default"].jPlayer.event.waiting), _htmlMediaEvents["default"].timeupdate, _jquery["default"].jPlayer.event.timeupdate), _htmlMediaEvents["default"].ended, _jquery["default"].jPlayer.event.ended), _htmlMediaEvents["default"].error, _jquery["default"].jPlayer.event.error);
    return _this;
  }
  (0, _createClass2["default"])(JPlayer, [{
    key: "on",
    value: function on(event, callback) {
      var jPlayerEvent = this.jPlayerEventMap[event];
      if (!jPlayerEvent) {
        return;
      }
      var callbackToUse = callback;
      if (jPlayerEvent === _jquery["default"].jPlayer.event.error) {
        callbackToUse = onError(callback, this.playerEl);
        this.cachedErrorCallback = callbackToUse;
      }
      this.jPlayerLibrary.on(jPlayerEvent, callbackToUse);
    }
  }, {
    key: "off",
    value: function off(event, callback) {
      var jPlayerEvent = this.jPlayerEventMap[event];
      if (!jPlayerEvent) {
        return;
      }
      var callbackToUse = callback;
      if (jPlayerEvent === _jquery["default"].jPlayer.event.error) {
        callbackToUse = this.cachedErrorCallback;
        delete this.cachedErrorCallback;
      }
      this.jPlayerLibrary.off(jPlayerEvent, callbackToUse);
    }

    /**
     * This is necessary on Safari mobile and desktop browsers due to autoplay restrictions.
     * See PlayerLoader.js for more details.
     * @param blankMp3Url {string}
     */
  }, {
    key: "preload",
    value: function preload(blankMp3Url) {
      this.jPlayerLibrary.jPlayer('setMedia', {
        mp3: blankMp3Url
      });
      this.jPlayerLibrary.jPlayer('play');
    }
  }, {
    key: "load",
    value: function load(url, format) {
      var _this2 = this;
      var mediaFormat = jPlayerFormatsMap[format];
      var media = (0, _defineProperty2["default"])({}, mediaFormat, url);
      return new Promise(function (resolve, reject) {
        _this2.jPlayerLibrary.one(_jquery["default"].jPlayer.event.canplay, resolve);
        _this2.jPlayerLibrary.one(_jquery["default"].jPlayer.event.error, onError(reject, _this2.playerEl));
        _this2.jPlayerLibrary.jPlayer('setMedia', media);
      });
    }
  }, {
    key: "play",
    value: function () {
      var _play = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(playPosition) {
        var _this3 = this;
        var playEvent, duration, percentage;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return new Promise(function (resolve, reject) {
                _this3.jPlayerLibrary.one(_jquery["default"].jPlayer.event.error, onError(reject, _this3.playerEl));
                _this3.jPlayerLibrary.one(_jquery["default"].jPlayer.event.playing, resolve);
                _this3.jPlayerLibrary.jPlayer('play');
              });
            case 2:
              playEvent = _context.sent;
              duration = (0, _get["default"])(playEvent, 'jPlayer.status.duration');
              percentage = (0, _timeToPercentage["default"])(playPosition, duration);
              if (percentage) {
                _context.next = 7;
                break;
              }
              return _context.abrupt("return");
            case 7:
              this.jPlayerLibrary.jPlayer('playHead', percentage);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function play(_x) {
        return _play.apply(this, arguments);
      }
      return play;
    }()
  }, {
    key: "seek",
    value: function seek(position) {
      // TUNE-9375 As late as Chrome 78, seeking to 100% causes player to hang for
      // several seconds before tuning to next topic
      this.jPlayerLibrary.jPlayer('playHead', position === 100 ? 99.99 : position);
    }
  }, {
    key: "pause",
    value: function pause() {
      this.jPlayerLibrary.jPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {
      this.jPlayerLibrary.jPlayer('stop');
    }
  }, {
    key: "canChangePlaybackRate",
    value: function canChangePlaybackRate() {
      return !!this.jPlayerLibrary.data('jPlayer').status.playbackRateEnabled;
    }
  }, {
    key: "getPlaybackRate",
    value: function getPlaybackRate() {
      return this.jPlayerLibrary.data('jPlayer').status.playbackRate;
    }

    // http://jplayer.org/latest/developer-guide/#jPlayer-option-playbackRate
  }, {
    key: "changePlaybackRate",
    value: function changePlaybackRate(rate) {
      this.jPlayerLibrary.jPlayer('playbackRate', rate);
    }
  }, {
    key: "unload",
    value: function unload() {
      this.jPlayerLibrary.jPlayer('clearMedia');
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.jPlayerLibrary.off();
      this.jPlayerLibrary.jPlayer('clearMedia');
      this.jPlayerLibrary.jPlayer('destroy');
    }
  }, {
    key: "setVolume",
    value: function setVolume(volume) {
      if ((0, _isNumber["default"])(volume)) {
        this.volume = volume;
        this.jPlayerLibrary.jPlayer('volume', volume / 100);
      }
    }
  }, {
    key: "getVolume",
    value: function getVolume() {
      return this.volume;
    }
  }, {
    key: "setTitle",
    value: function setTitle(title) {
      this.jPlayerLibrary.jPlayer('setMedia', {
        title: title
      });
    }
  }, {
    key: "getTimes",
    value: function getTimes() {
      var jPlayer = this.jPlayerLibrary.data('jPlayer');
      return {
        elapsedPercent: +jPlayer.status.currentPercentAbsolute.toFixed(6),
        elapsedSeconds: Math.floor(jPlayer.status.currentTime),
        duration: Math.floor(jPlayer.status.duration)
      };
    }
  }]);
  return JPlayer;
}(_Player2["default"]);
//# sourceMappingURL=JPlayer.js.map